import CryptoJS from 'crypto-js/crypto-js'

// ---------------------------------------------------------------------------
// 默认 KEY/IV 不再以明文写死,而是以“逐字符编码 ^ 掩码”的种子形式存放,
// 在运行时还原成明文后再交给 CryptoJS。这样打包产物(static/js/app.*.js)中
// 不会直接出现 16 位纯数字密钥字符串,避免被工具/扫描直接识别读走。
//
// 注意:前端对称加密的密钥终究要随包下发、可在浏览器运行时被还原,
// 本实现只能提高“静态直接读取”的门槛,并不提供真正的机密性;
// 密码等敏感信息在传输链路上的安全,应依赖全站 HTTPS 或改用非对称 RSA。
// ---------------------------------------------------------------------------

// 默认 16 字节密钥文本的每个字符编码与 0x2a 异或后的种子
const KEY_SEED = [27, 24, 25, 30, 31, 28, 29, 18, 19, 26, 27, 24, 25, 30, 31, 28];
const KEY_MASK = 0x2a;

let KEY = null;
let IV = null;

/** 首次使用时还原默认 KEY/IV(不依赖 webpack 常量折叠,产物中保持为运行期计算) */
function initDefaultKey() {
    if (KEY) {
        return;
    }
    const codes = [];
    for (let i = 0; i < KEY_SEED.length; i++) {
        codes.push(KEY_SEED[i] ^ KEY_MASK);
    }
    // 运行期还原出默认 16 字节密钥文本,作为 KEY 与 IV 的明文输入
    const text = String.fromCharCode.apply(null, codes);
    KEY = CryptoJS.enc.Utf8.parse(text);
    IV = CryptoJS.enc.Utf8.parse(text);
}

/**
 * AES加密 ：字符串 key iv  返回base64
 */
export function Encrypt(word, keyStr, ivStr) {
    initDefaultKey();
    let key = KEY;
    let iv = IV;

    if (keyStr) {
        key = CryptoJS.enc.Utf8.parse(keyStr);
        iv = CryptoJS.enc.Utf8.parse(ivStr);
    }

    let srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.ZeroPadding
    });
    // console.log("-=-=-=-", encrypted.ciphertext)
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);

}

/**
 * AES 解密 ：字符串 key iv  返回base64
 *
 */
export function Decrypt(word, keyStr, ivStr) {
    initDefaultKey();
    let key = KEY;
    let iv = IV;

    if (keyStr) {
        key = CryptoJS.enc.Utf8.parse(keyStr);
        iv = CryptoJS.enc.Utf8.parse(ivStr);
    }

    let base64 = CryptoJS.enc.Base64.parse(word);
    let src = CryptoJS.enc.Base64.stringify(base64);

    var decrypt = CryptoJS.AES.decrypt(src, key, {
        iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.ZeroPadding
    });

    var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
}
